import styled from 'react-emotion';

const StudentContainer = styled('div')`
  margin-top: 16px;
`;

export default StudentContainer;
